var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyInboxinline = function SvgEmptyInboxinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 34"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#empty-inbox_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#empty-inbox_inline_svg__b)",
    d: "M29.97 12.5a1.1 1.1 0 0 0-.16-.35c-.008-.011-.01-.024-.017-.036-.005-.008-.014-.011-.02-.019a1 1 0 0 0-.218-.22l-11.92-8.667a1.08 1.08 0 0 0-1.274 0L4.446 11.874a1.1 1.1 0 0 0-.22.221c-.005.008-.014.01-.02.018-.007.01-.008.024-.015.035a1.1 1.1 0 0 0-.162.352q0 .01-.002.019A1 1 0 0 0 4 12.75v13A3.254 3.254 0 0 0 7.25 29h19.5A3.254 3.254 0 0 0 30 25.75v-13q0-.116-.027-.23zM16.999 5.423l10.076 7.328-10.074 7.327-10.076-7.327z",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-inbox_inline_svg__b",
    x1: 17,
    x2: 17,
    y1: 3,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("filter", {
    id: "empty-inbox_inline_svg__a",
    width: 34,
    height: 34,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21318_22993"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_21318_22993",
    result: "shape"
  })))));
};
export default SvgEmptyInboxinline;